const state = {
    aisLinkToken: null,
    aisEmail: null,
    redirectUri: null,
    isUpdateMode: false,
    itemId: null,
};

const mutations = {
    SET_AIS_LINK_TOKEN(state, payload) {
        state.aisLinkToken = payload;
    },
    SET_AIS_EMAIL(state, payload) {
        state.aisEmail = payload;
    },
    SET_AIS_REDIRECT_URI(state, payload) {
        state.redirectUri = payload;
    },
    SET_AIS_IS_UPDATE_MODE(state, payload) {
        state.isUpdateMode = payload;
    },
    SET_AIS_ITEM_ID(state, payload) {
        state.itemId = payload;
    },
};

export default {
    namespaced: true,
    state,
    mutations,
};
